module.exports = __webpack_public_path__ + "img/icon-alert-red.cf4c708e.svg";